import { useEffect, useState } from "react";
import { CalendarClock, GraduationCap, Volleyball } from "lucide-react";

const TARGETS = [
  { id: "move-in", label: "Move-In & Preseason", date: "2026-08-11T09:00:00", icon: CalendarClock, note: "Aug 11, 2026" },
  { id: "first-day", label: "First Day of School", date: "2026-08-27T08:00:00", icon: GraduationCap, note: "Aug 27, 2026" },
  { id: "home-game", label: "First Home Game", date: "2026-09-05T13:00:00", icon: Volleyball, note: "Sep 5, 2026 · TBD" },
];

function diff(target) {
  const ms = new Date(target) - new Date();
  if (ms <= 0) return null;
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor(ms / 3600000) % 24,
    m: Math.floor(ms / 60000) % 60,
    s: Math.floor(ms / 1000) % 60,
  };
}

export default function Countdown() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="countdown" className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 -mt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="countdown-section">
        {TARGETS.map((t) => {
          const r = diff(t.date);
          const Icon = t.icon;
          return (
            <div
              key={t.id}
              data-testid={`countdown-${t.id}`}
              className="rounded-3xl bg-zinc-900/90 backdrop-blur-xl border border-purple-500/20 hover:border-purple-500/50 p-6 md:p-8 transition-colors duration-300 shadow-[0_0_30px_rgba(147,51,234,0.12)]"
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-purple-600/20 border border-purple-500/40 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-purple-400" />
                </div>
                <div>
                  <p className="font-sub font-bold text-white text-sm">{t.label}</p>
                  <p className="font-sub text-xs text-zinc-500">{t.note}</p>
                </div>
              </div>
              {r ? (
                <div className="grid grid-cols-4 gap-2">
                  {[["Days", r.d], ["Hrs", r.h], ["Min", r.m], ["Sec", r.s]].map(([u, v]) => (
                    <div key={u} className="rounded-xl bg-zinc-950 border border-white/5 py-3 text-center">
                      <p className="font-display text-2xl md:text-3xl text-white leading-none">{String(v).padStart(2, "0")}</p>
                      <p className="font-sub text-[10px] uppercase tracking-widest text-zinc-500 mt-1">{u}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="font-display text-2xl text-purple-400 uppercase">It's here! 💜</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
